import { Route, Routes } from "react-router-dom";
import UpdatesControl from "./list";

export default function UpdatesControlRoutes() {
  return (
    <Routes>
      <Route path="" element={<UpdatesControl />} />
      <Route path="/:id" element={<UpdatesControl />} />
    </Routes>
  );
}
